module.exports = __webpack_public_path__ + "media/images/webpage/hotels/108/plan3-1-d06e4c3e84b9e414a077dd5aa8701cb8.webp";